import styled from "styled-components";
import { WrapperContainer } from "../../../components";
import { FirmwareInputVersionWrapper } from "../../../components/FirmwareVersionInput/styled";

export const FWUNameContainer = styled(WrapperContainer)`
  ${FirmwareInputVersionWrapper} {
    width: 100%;
  }
`;

export const FormWrapper = styled(WrapperContainer)`
  min-height: calc(100vh - 130px);
`;
